import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  leadData: [],
};

const leadSlice = createSlice({
  name: 'leads',
  initialState,
  reducers: {
    setLoginLead: (state, action) => {
      state.leadData = action.payload;
    },
    
    resetData: (state) => {
      state.leadData = [];
    }
  }
});

export const { setLoginLead, resetData } = leadSlice.actions;
export default leadSlice.reducer;